/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查看订单的支付信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class PayInfoParams {
  constructor(public billNo?: string) {}
}

export default async function (
  params: PayInfoParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: payment.PayInfo;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/payment/pay-info`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
